import { Taxonomy } from "../categories";
import {
    isUncategorizedAccount,
    UncategorizedAccountPredicateInput,
} from "./accounting/uncategorized-account";

/**
 * Whether a CATEGORY field is eligible to be marked as reviewed: the
 * category must exist and not be the workspace's "Uncategorized" taxonomy.
 * Shared between the transaction-field-review backend service and every
 * frontend surface (transaction details drawer, review task cells) so a
 * transaction can never be marked "category reviewed" while still
 * uncategorized.
 */
export function isCategoryTaxonomyReviewEligible(
    taxonomy: string | null | undefined,
): boolean {
    return taxonomy != null && taxonomy !== Taxonomy.uncategorized;
}

/**
 * Whether a CASH_LEDGER / ACCRUAL_LEDGER field is eligible to be marked as
 * reviewed: the ledger must resolve to an account, and that account must not
 * be one of the "Uncategorized Income/Expenses" placeholder accounts. A
 * `null`/missing account (blank ledger) is never eligible either. Shared
 * between the backend service and the frontend ledger cells so "blank" and
 * "still uncategorized" are treated identically everywhere.
 */
export function isLedgerAccountReviewEligible(
    account: UncategorizedAccountPredicateInput | null | undefined,
): boolean {
    return account != null && !isUncategorizedAccount(account);
}
